<template>
  <b-container>
    <b-row class="header bg-info d-none d-md-flex">
      <b-col md="2" class="cell">CHAPITRE</b-col>
      <b-col md="4" class="cell">QUESTION</b-col>
      <b-col md="3" class="cell">VOTRE RÉPONSE</b-col>
      <b-col md="3" class="cell">RÉPONSE ATTENDUE</b-col>
    </b-row>
    <template v-for="d in exam">
      <b-row v-if="d.question != null" :key="d.id" class="exam-data">
        <b-col xs="12" md="2" class="cell font-weight-bold">
          <b-link :to="{name: 'Course', params: { moduleId: moduleId, chapterId: d.question.chapter.id }}">
            {{ d.question.chapter.title }}
          </b-link>
        </b-col>
        <b-col xs="12" md="4" class="cell font-weight-bold">{{ d.question.question_title }}</b-col>
        <b-col xs="12" md="3" class="answer cell">
          <span>
            <b-icon :icon="icon(d)" :variant="variant(d)" scale="1.5"></b-icon>
            &nbsp;
            <span v-if="d.question.question_type=='hotspot' && d.is_success==true">Position correcte</span>
            <span v-else-if="d.question.question_type=='hotspot' && d.is_success==false">Position fausse</span>
            <span v-else-if="d.question.question_type=='DDP'">
              <ul>
                <li v-for="(a, i) in splitDdpAnswer(d.user_answer)" :key="i">{{ a }}</li>
              </ul>
            </span>
            <span v-else-if="d.question.question_type=='DDL' || d.question.question_type=='DDS'">
              <ul>
                <span v-for="(a, i) in d.user_answer.split('; ')" :key="i">
                  <li>{{ a }}</li>
                </span>
              </ul>
            </span>
            <span v-else>{{ d.user_answer }}</span>
          </span>
        </b-col>
        <b-col xs="12" md="3" class="answer cell">
            <span v-if="d.question.question_type=='hotspot'">
              <span>
                {{ hotspotZonesNumber(d.question.answers) }}
              </span>
            </span>
            <span v-else-if="d.question.question_type=='DDP'">
              <ul>
                <li v-for="(a, i) in d.question.answers" :key="i">{{ splitDdpAnswer(a.answer_value)[0] }}</li>
              </ul>
            </span>
            <span v-else-if="d.question.question_type=='DDL'">
              <ul>
                <span v-for="(a, i) in d.question.answers" :key="i">
                  <li v-if="a.is_correct==true">{{ a.answer_value }}</li>
                </span>
              </ul>
            </span>
            <span v-else-if="d.question.question_type=='DDS'">
              <ul>
                <span v-for="(a, i) in d.question.answers[0].answer_value.split('; ')" :key="i">
                  <li>{{ a }}</li>
                </span>
              </ul>
            </span>
            <span v-else>
              <span>
                {{ getCorrectMcqAnswer(d.question.answers) }}
              </span>
            </span>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
export default {
  data () {
    return {
        question: {}
    }
  },
  computed:{
      moduleId() {return parseInt(this.$route.params.id)},
  },
  props: {
      exam: Array
  },
  methods: {
    icon (examData) {
      return (examData.is_success==true) ? 'check-circle-fill' : 'x-circle-fill'
    },
    variant (examData) {
      return (examData.is_success==true) ? 'success' : 'danger'
    },
    splitDdpAnswer(userAnswer) {
      let spitAnswer = []
      userAnswer = userAnswer.split(";")
      userAnswer.forEach((answer, i) => {
        spitAnswer[i] = answer.replace("=>", " : ")
      })
      return spitAnswer
    },
    getCorrectMcqAnswer(answersList) {
      let correctAnswer="";
      answersList.forEach((answer) => {
        if(answer.is_correct == true) {
          correctAnswer = answer.answer_value;
          return 
        }
      })
      return correctAnswer;
    },
    hotspotZonesNumber(answersList) {
      let nbZones = answersList.length;
      if (nbZones > 1) {
        return nbZones+" zones de réponse possibles."
      } else {
        return nbZones+" zone de réponse possible."
      }
    }
  }
}
</script>

<style scoped>
.cell {
    display: grid;
    align-items: center;
    margin-bottom: 5px;
}
.answer>span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.answer, .answer>span, .answer>span>span, .answer>span>span>span, .answer>span>ul {
  width: 100%;
}
.header {
  font-weight: bold;
  height: 3rem;
}
.exam-data {
    margin-bottom: 0.75rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    border-bottom: dashed 0.5px #aaa;
}
li {
  margin-bottom: 8px;
}
</style>